
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as policy9DF_hG4BBbTDb2gG754n2DW2zpRkbq6CdI0hVSAvNrgMeta } from "/src/app/pages/account/security-and-legal/policy.vue?macro=true";
import { default as securitymZU65dGBlXU3EJlPi9mXL8GBVecY7g8uf41hFRvirk4Meta } from "/src/app/pages/account/security-and-legal/security.vue?macro=true";
import { default as sessionsGKpWzhUrEadGo_gOmPG1VXpROOMOWces91e6RhdoUZYMeta } from "/src/app/pages/account/security-and-legal/sessions.vue?macro=true";
import { default as rolesWKDH4Cgyux85_TziShT98cWiHwTuxNPBrv66bO01TksMeta } from "/src/app/pages/account/team/roles.vue?macro=true";
import { default as usersYGEHu9hGlWwzeEXaO40wmXNMTcQOmNC7Ze8eWedLeGUMeta } from "/src/app/pages/account/team/users.vue?macro=true";
import { default as printerODQ2EXbDUbkzhqGowuAZIv3M6pA8_N0_YtJZDlOxwMeta } from "/src/app/pages/customer/form/print.vue?macro=true";
import { default as accountszF_CSfZsuk_QNt17xf0yMZJFNMXZBwmoK9wsDbAx3gMeta } from "/src/app/pages/manage/business/account.vue?macro=true";
import { default as address__6E2Cf2P0uttEefJegz2VY1lNRp_ZGHcRLpSWNKqFAMeta } from "/src/app/pages/manage/business/address.vue?macro=true";
import { default as notesHB4WWLBjrkxgPl3Pf8iRr7yQ8BD1j0LlPTCBCuaTfrEMeta } from "/src/app/pages/manage/business/notes.vue?macro=true";
import { default as schedule8HbE5Lm13iVmJyJChMGX4Y0reKzLQT7o2DWPp_hX4zcMeta } from "/src/app/pages/manage/business/schedule.vue?macro=true";
import { default as terminologyZVEP6cyT6R9tB9_9O7lCXywIZfWyHJlkuUPy9XUjNjYMeta } from "/src/app/pages/manage/business/terminology.vue?macro=true";
import { default as emailp6ZZlycKoj0EHWhKyZdPvK1XlZn0EXxWtvcJCkOclXMMeta } from "/src/app/pages/manage/communications/email.vue?macro=true";
import { default as remindersBbIfiHrX2U7AnsGjx3UCYgdG3XrW1GK4KZEOWxS1T7cMeta } from "/src/app/pages/manage/communications/reminders.vue?macro=true";
import { default as smsee3XoPhMnve8GMzef2MJsbh7QNqy9tWWSae80YgP6PIMeta } from "/src/app/pages/manage/communications/sms.vue?macro=true";
import { default as templatesXoBz3Nrxi0WZywyd_kuo9p7wZS32ArtrA9Up24DlXlIMeta } from "/src/app/pages/manage/communications/templates.vue?macro=true";
import { default as customer_45gift_45cardsICjyKWFJgrjWui6NgiEqvaV05TPuLF6rU2CydxFdZwgMeta } from "/src/app/pages/manage/loyalty-and-promotions/customer-gift-cards.vue?macro=true";
import { default as customer_45passykpUjXSk_HPeYXCq1ibUVKiEmJTOqYEm3ce6KA7PYOMMeta } from "/src/app/pages/manage/loyalty-and-promotions/customer-pass.vue?macro=true";
import { default as passVtrwwoBD8eNRIfdPqeGOwM16lpLZSgkh3b_DYm2PCa0Meta } from "/src/app/pages/manage/loyalty-and-promotions/pass.vue?macro=true";
import { default as promo_45codesqO5_SuNRZVP4dw8jXgAlBlmFoDJ2JtGf8fwFlLDHJnAMeta } from "/src/app/pages/manage/loyalty-and-promotions/promo-codes.vue?macro=true";
import { default as segmentsYxyiKeb9ldct1axSBpgZEF0M3QW4UNDe4MhMJUI7kNcMeta } from "/src/app/pages/manage/marketing/segments.vue?macro=true";
import { default as brandsxSNpnXWwkcz_LeYfdHZZ7QDrb_ixfZJcnoaC9zIWUj4Meta } from "/src/app/pages/manage/products/brands.vue?macro=true";
import { default as categoriesalsCPSXBcyMsnVnGdi4MKPf_SggAr3Lze_ntgaUTuN4Meta } from "/src/app/pages/manage/products/categories.vue?macro=true";
import { default as listxuG_XoUAUsfRXbYqXfnOvnfCQIW0gH52go4fkEU6KR0Meta } from "/src/app/pages/manage/products/list.vue?macro=true";
import { default as purchase_45ordersgrNs8C7v3GDH58Ves6n5_p3nY6uH_1DuozLixDoVK9sMeta } from "/src/app/pages/manage/products/purchase-orders.vue?macro=true";
import { default as stock_45takeg_0fy32VBQvn_NuK6LC3b5Xyh3kky9TX37Dr2eFt2oIMeta } from "/src/app/pages/manage/products/stock-take.vue?macro=true";
import { default as supplierssH0Cu6XOBGq2uKxrxTC_tM5QPqt9k08UYX8DbXooRZoMeta } from "/src/app/pages/manage/products/suppliers.vue?macro=true";
import { default as groupsydubiX7dqxN4sZkv5kENdRzR6DcbsIL36dTHiRRDMQIMeta } from "/src/app/pages/manage/resources/groups.vue?macro=true";
import { default as listocY3JQItz8V8MGGWx1dHQm5uQgPqTIud0oSCs5fpQrQMeta } from "/src/app/pages/manage/resources/list.vue?macro=true";
import { default as chargesppw_mWg_IkuC62agFAaOYK2coDjK0kpbc3hf9N7gXo8Meta } from "/src/app/pages/manage/sales-setup/charges.vue?macro=true";
import { default as discounts27To8Fzd___qshHaS0a3hGtJHQT61f_yGl1IR_yhj6MMeta } from "/src/app/pages/manage/sales-setup/discounts.vue?macro=true";
import { default as payments526hIKL7QMTA_TPW39cWqF1S8z39oFcVjK58IwY64S8Meta } from "/src/app/pages/manage/sales-setup/payments.vue?macro=true";
import { default as taxesprw1ZQk_ince9gGK3H7yhE8SWyUt2gk7Bcz_sR7_R98Meta } from "/src/app/pages/manage/sales-setup/taxes.vue?macro=true";
import { default as aftercare_45templateslM3z_79VixukxSDYvVYtPY0OytXCEOfkCsKLZUYBLNgMeta } from "/src/app/pages/manage/services/aftercare-templates.vue?macro=true";
import { default as cancellation_45reasonszZyecoaNKMX8dEgZufPEWkPsuM23nzPIWJIw9InLMK0Meta } from "/src/app/pages/manage/services/cancellation-reasons.vue?macro=true";
import { default as categoriesFtkJIFfvzw9MSHQDVyl8BU1jz_rG0K27z5qKwka6dz8Meta } from "/src/app/pages/manage/services/categories.vue?macro=true";
import { default as listtfwtm75PoNl8BZ5KJfXlJRDVNjQ0T2wvpQjIVL0aZ6wMeta } from "/src/app/pages/manage/services/list.vue?macro=true";
import { default as status_45typesTT9mNsKjAficr211ZvO857455dUwZ42n8g6d12T6oowMeta } from "/src/app/pages/manage/services/status-types.vue?macro=true";
import { default as employeesHiGCNLn5aHO_JicWt562UcZM8MjSVAKfY9h2KUUN6u8Meta } from "/src/app/pages/manage/team/employees.vue?macro=true";
import { default as domainmh7mtlErIPLyAmollB_UiRROlBepHrPiE0dR6tGu038Meta } from "/src/app/pages/minisite/advanced/domain.vue?macro=true";
import { default as scriptUSporitqTDmrfpW2BEO_f_vFQZ8amOJ0iPHWHZtTXrIMeta } from "/src/app/pages/minisite/advanced/script.vue?macro=true";
import { default as seoD7sFOUwEKtu9DbAxcjKeDO_j_HlpBz65i2CtcKzQpAAMeta } from "/src/app/pages/minisite/advanced/seo.vue?macro=true";
import { default as hourseqTekeLoM_oQxm7qOQc5eG6CsxeHs1_66I1ROn7RYIEMeta } from "/src/app/pages/minisite/business-info/hours.vue?macro=true";
import { default as socialur4v83oAnzmJUMHpLA4C5igI1dOri_hoa_XEUv2U2mkMeta } from "/src/app/pages/minisite/business-info/social.vue?macro=true";
import { default as bookingQUC_Q50lcFTxjkLsfa_E8NORtVOvZbxfwgbqKLeqmeoMeta } from "/src/app/pages/minisite/pages/booking.vue?macro=true";
import { default as coursesNhxWyxi8OTwzIJBVbgScg2mTEdLGHuZdCzsZKaf9kDwMeta } from "/src/app/pages/minisite/pages/courses.vue?macro=true";
import { default as custom_45pagesabYVRDm1zPLQOh7HPH08hsqJ4B5mOJZxH_jwgoMkGO4Meta } from "/src/app/pages/minisite/pages/custom-pages.vue?macro=true";
import { default as customerBZkFr6qOg6YLgiZzPWWUR_c5OcUQP8LhaZOYGDIqS_AMeta } from "/src/app/pages/minisite/pages/customer.vue?macro=true";
import { default as galleryCG4jf2BcHhsEJdhDVNGTAyb029s7W2Jry6V3qbWzy6kMeta } from "/src/app/pages/minisite/pages/gallery.vue?macro=true";
import { default as gift_45cardsWUqfDcPsh7qujG_jOecqT5QWSD8NplyCeyNK_D8hyMEMeta } from "/src/app/pages/minisite/pages/gift-cards.vue?macro=true";
import { default as passesTG8n5YOuQlZLj7atQ_pkQYJsxjDQIPsQd_KOHqbjznkMeta } from "/src/app/pages/minisite/pages/passes.vue?macro=true";
import { default as reviews1I4gTF0cBSUCIt4a7RLw7_QrH0AwOFvNnKeTepH49MQMeta } from "/src/app/pages/minisite/pages/reviews.vue?macro=true";
import { default as monthSMDkKQc8MaYwdH1goSvXb6UaWgO2_qMaFxRR_PUVQisMeta } from "/src/app/pages/roster/print/month.vue?macro=true";
import { default as weekMKfGB13s4pVrFrlPvEJdrjJtiyX7GCZoUWQ3EYzmy40Meta } from "/src/app/pages/roster/print/week.vue?macro=true";
import { default as _91type_934MLOM4pqa_mH9B_VWrWrizs52LdxB5uSqY475ZYyFrgMeta } from "/src/app/pages/manage/custom-fields/[type].vue?macro=true";
import { default as accountCP24f_75COwagbGymqxVEUeBav4FiKYnodzYAR_slHoMeta } from "/src/app/pages/account/account.vue?macro=true";
import { default as calendar_45feedsoyJWY7CbCluURoeQDlJCLXop4jJM4RxkaBcnq0mm_hQMeta } from "/src/app/pages/account/calendar-feeds.vue?macro=true";
import { default as exportsXNXHBOBs3rMSh_LbWQ5TRms3DBrCjpYp7Auc_dTJM_EMeta } from "/src/app/pages/account/exports.vue?macro=true";
import { default as inactivengWCyO6QEz_r_D2J18YrbdXntB3V589UNFfvtCm832AMeta } from "/src/app/pages/account/inactive.vue?macro=true";
import { default as integrationslESSa_x6Td2I51yzIi8TJ1WHYHkkOuN4AHLvs5kJCuYMeta } from "/src/app/pages/account/integrations.vue?macro=true";
import { default as local_45cachel5zwShpGAQv228fQLW3lGlImykIew2TVrAQyzbjAPG8Meta } from "/src/app/pages/account/local-cache.vue?macro=true";
import { default as indexqWhAPhoUKjwc_NLMfWs7zb_VpH8Fy5fBbt9iN4jqyyUMeta } from "/src/app/pages/account/security-and-legal/index.vue?macro=true";
import { default as subscribe_UxwQp1GoYKOV2XQhmWTTDZKkH9TEVC6uJvAjN_qlJoMeta } from "/src/app/pages/account/subscribe.vue?macro=true";
import { default as unsubscribeNLqAg08j2lXDQoT2wRjYeu_lcLWi0lkaSGcR0BuAHecMeta } from "/src/app/pages/account/unsubscribe.vue?macro=true";
import { default as verifyC__cthop_ovawlULZHa7OKthul_L6fIRiKZDBViwSgIMeta } from "/src/app/pages/account/verify.vue?macro=true";
import { default as indexxFSUVdhXYklTPnX0M89WBp_veQYSfsHIDiZkUKookNgMeta } from "/src/app/pages/manage/business/index.vue?macro=true";
import { default as course_45typesMAtGKzBZHpBAGkZxxjSOb98QsMvRrIHgy20IwZr0ZlwMeta } from "/src/app/pages/manage/course-types.vue?macro=true";
import { default as coursesAYZTQfO6WOXQiuHhGsTvR2LuicZLddulBLatzFLaIR4Meta } from "/src/app/pages/manage/courses.vue?macro=true";
import { default as indexQERyhcMMzr0H31MvjSfRBXEFvPou3JveejBIxJwZcUwMeta } from "/src/app/pages/manage/custom-fields/index.vue?macro=true";
import { default as devicessoQTZgNaKlT2366FMfduhfUjrw3YUtpOSkotLYzhkbMMeta } from "/src/app/pages/manage/devices.vue?macro=true";
import { default as formssrFT9fGHd3YB_DJarLKH0P4bdRwsAE9FsgbBUQxd60UMeta } from "/src/app/pages/manage/forms.vue?macro=true";
import { default as indexbe1K4ojsa_BFlqBH28wz3FUEYcJHE3_AZBBT5VPlKRoMeta } from "/src/app/pages/manage/loyalty-and-promotions/index.vue?macro=true";
import { default as indexIReB49EiXDDCUXMtDKo6JM3Pp7K4T5MxkOyFetkq4PQMeta } from "/src/app/pages/manage/products/index.vue?macro=true";
import { default as indexI55IWuolHv2If94IKlpIQJsQzLtcGQ3VnaScVbgXrVsMeta } from "/src/app/pages/manage/resources/index.vue?macro=true";
import { default as indexQRS3XBze27n8bJJ65mQCyWKXrPqnGGeVTy2RJsB7cF0Meta } from "/src/app/pages/manage/sales-setup/index.vue?macro=true";
import { default as indexSB4_M9SNSkXnlSMAh2nMCMn2I6nKWmcuEsHfAwOixxUMeta } from "/src/app/pages/manage/services/index.vue?macro=true";
import { default as indexbGpMPDujlyH__bzB3FV8XU6UlNq_sqTbtwOq7pb3_aMMeta } from "/src/app/pages/manage/team/index.vue?macro=true";
import { default as indexFI_n_dy6drrflA8aoujfZtPB_B5F_YFGtRNUG1newo4Meta } from "/src/app/pages/minisite/advanced/index.vue?macro=true";
import { default as indexW5Wh_3SnSMM2UXzZfjh_g3_EeLapgGXguBQrZpkfkdMMeta } from "/src/app/pages/minisite/business-info/index.vue?macro=true";
import { default as embed0bDtlTDjUFNQKnCy8uJQJBY_U_Fhwk1ntxVsxwWonesMeta } from "/src/app/pages/minisite/embed.vue?macro=true";
import { default as menua0QYRDW5_Q9vBQxMegqtQ5l2mBHg_WulGcBCmRlPS4EMeta } from "/src/app/pages/minisite/menu.vue?macro=true";
import { default as minimise_45gapszXUpohO6IXWs__sPkPpCSyo_PWeJMj6Lkfe3oc_twr0Meta } from "/src/app/pages/minisite/minimise-gaps.vue?macro=true";
import { default as new_45customersBYBY8_slMfTzLk0eMERjhobwTBFHiVglFDbyZQpblHIMeta } from "/src/app/pages/minisite/new-customers.vue?macro=true";
import { default as indexebAH3N40v_gV98oYMXza_7aonGkaki6Ak7YJSvejlK4Meta } from "/src/app/pages/minisite/pages/index.vue?macro=true";
import { default as paymentsQexd8rbqRhu3YMy8SOqnEgfy_RhcSOUVhoUfVqB8tl4Meta } from "/src/app/pages/minisite/payments.vue?macro=true";
import { default as preferencesXPSD_GdEPPMbPumV3oH8JRCZCjxx0iCh_gv_oIYcLOUMeta } from "/src/app/pages/minisite/preferences.vue?macro=true";
import { default as site_45noticeeX6LXUUf4xxurc8q1cUM_t83N1LswG3zt4iBzbZnwX0Meta } from "/src/app/pages/minisite/site-notice.vue?macro=true";
import { default as terms_45and_45policy2vmqO2OL3scTfIZfriMUQFFq8A8HjMLWR4sgUXJxV7oMeta } from "/src/app/pages/minisite/terms-and-policy.vue?macro=true";
import { default as theme372gY3RNziR5Wlyr0NtWETvoBkGwBsYCS1x6CVbi7aYMeta } from "/src/app/pages/minisite/theme.vue?macro=true";
import { default as editoGIstUjomVhMp9X0gpWwT8Ll9_n8V33QuhtMQUr8Zt8Meta } from "/src/app/pages/template/edit.vue?macro=true";
import { default as connectSU3MJ_BEM5uY41PwL0NWTTjuOS7Lsaq9RZYEtb65808Meta } from "/src/app/pages/integration/[id]/connect.vue?macro=true";
import { default as _91id_93qAfSAbMDokR5ZnNKltgsFDPb4U8hgK56jYrvGZZjf2QMeta } from "/src/app/pages/custom-page/[id].vue?macro=true";
import { default as _91id_93fQ2oUCHP_hVNgRKXnlCzdipP6W6kABx_plRqBSd3PtIMeta } from "/src/app/pages/customer/[id].vue?macro=true";
import { default as _91id_93miyRBeo2PN9g48GhfcXCBNqntFIlFyZHlP_krCJIkv8Meta } from "/src/app/pages/form/[id].vue?macro=true";
import { default as _91_46_46_46legacy_937Fl_R5qUn8uYcO2alL9Sx8OFMi7hLNs8J_Xkzc1qtVYMeta } from "/src/app/pages/online-booking/[...legacy].vue?macro=true";
import { default as _91_46_46_46legacy_93EoG2XiIvOursqXre55T4ZANSotClbys2rxK_aaTA3SsMeta } from "/src/app/pages/settings/[...legacy].vue?macro=true";
import { default as indexFblcUjJkxyhRfk_3NHVSCyOEJUrtZPmfifyNxvgRErAMeta } from "/src/app/pages/account/index.vue?macro=true";
import { default as accountsvrsDJ_k6QpUyBjvx5M9CNf11TUysmUXQZFGagqxVbfMMeta } from "/src/app/pages/auth/index/find/index/accounts.vue?macro=true";
import { default as codeu9mUNqGXMwQGjkp4RnmNHRCaCoxfBAk_xLJ6EZtCbc8Meta } from "/src/app/pages/auth/index/find/index/code.vue?macro=true";
import { default as domainbIJKBg3ViMBdAEWLxFBR4wddB_MluG6CXdURg7U3O1kMeta } from "/src/app/pages/auth/index/find/index/domain.vue?macro=true";
import { default as emailG9hfbxLlguIgbofI3uuvEWNLKCCkvZ8izKl_bRBB7A0Meta } from "/src/app/pages/auth/index/find/index/email.vue?macro=true";
import { default as indexMuguBtXlm30uTC2vD78Fk_Tpwt2M1UGVZeogE6naf54Meta } from "/src/app/pages/auth/index/find/index.vue?macro=true";
import { default as connectjUfoi5GmlpJrYnKQzQZfKRPll2ORz0C8PKQIuSxYhDcMeta } from "/src/app/pages/auth/index/integration/index/[guid]/connect.vue?macro=true";
import { default as indextMj4CLDOiHj1mlLQOQULIdGOC81QW907Kgb5QM5lZlMMeta } from "/src/app/pages/auth/index/integration/index.vue?macro=true";
import { default as codeSdo6Ih5eVjrP4Y5cvgHCSkbn9nHJM2F6_W9glY_wfZgMeta } from "/src/app/pages/auth/index/login/index/code.vue?macro=true";
import { default as emailaODphKPYiQrCMYLX09Kj2u0wUZNnQKSEQzOTKzSrawQMeta } from "/src/app/pages/auth/index/login/index/email.vue?macro=true";
import { default as password_z_Kfxlx4sZ9xnEHfsYPAwnOjv7oHflsIL5HeBya_S4Meta } from "/src/app/pages/auth/index/login/index/password.vue?macro=true";
import { default as indexHe0l7BP4Xdyl_CNau_jlon4lQNVsDndKB5m2ExvKad8Meta } from "/src/app/pages/auth/index/login/index.vue?macro=true";
import { default as pin_SOM4bypKxtWtJU9BtIdQ1_qV_JsP2aGtQpTz6cTgesMeta } from "/src/app/pages/auth/index/pin.vue?macro=true";
import { default as confirm4RBbvZ0H26F5aqAOJviG_QCdi8LEk8IxEsFwe5JViQYMeta } from "/src/app/pages/auth/index/reset/index/confirm.vue?macro=true";
import { default as emailknV3h2wtMqtmNqQycos7_3nY2OPfPBlqTWvEW8L49_QMeta } from "/src/app/pages/auth/index/reset/index/email.vue?macro=true";
import { default as indexRhd0JPUqLfkPBr7diAJV2hAgXK3TQrMc_fiSr4ikl_wMeta } from "/src/app/pages/auth/index/reset/index.vue?macro=true";
import { default as switchB6tPwqiiwWdfTELhF34jpxT7XaklTd74JVjz29cst6AMeta } from "/src/app/pages/auth/index/switch.vue?macro=true";
import { default as tokenzeWz5CC8WOifmBNiy8_U_QpwdSkfbphGF3zfdCSG8t8Meta } from "/src/app/pages/auth/index/token.vue?macro=true";
import { default as verifyd8GUfCLso4ecP41whdDbW2iKR_reIlVUlK5SCIz5Y6kMeta } from "/src/app/pages/auth/index/verify.vue?macro=true";
import { default as index39kX9Yt_pDI8bdbuYMXmSbSM37eYGUI92l686jI6wmwMeta } from "/src/app/pages/auth/index.vue?macro=true";
import { default as indexVyq32YJh0b_brcA0z1byNUK4E4BXqWOiuc_BiCfHVEYMeta } from "/src/app/pages/customer/index.vue?macro=true";
import { default as index8azzhfNUmdzVQNl1TVtUGusgFSsfqBYT_Y7foXhORIMMeta } from "/src/app/pages/demo/index.vue?macro=true";
import { default as elementsBONxDd_YEeH6f5ArlGPOu_tjxXPXt4gpZOvi6_L5kQwMeta } from "/src/app/pages/elements.vue?macro=true";
import { default as indexdGJHZOaJPDqLW512YnUImKKb3Lj33OBxlsuEwZLESlgMeta } from "/src/app/pages/manage/index.vue?macro=true";
import { default as _91id_93UrP8hLkAX4_b7Vb7udyD7Yzhy9ZTSOXRmatj6rbi0ZoMeta } from "/src/app/pages/marketing/index/campaigns/report/[id].vue?macro=true";
import { default as _91channel_93HXi0V43c1zYz52WZrH2gaIilfn7op9RDkbCcncDDt_kMeta } from "/src/app/pages/marketing/index/messages/[channel].vue?macro=true";
import { default as index8_R1bDRf421EKs5KPwF8oF_3Q1iqKfNhLJrxan2EkmcMeta } from "/src/app/pages/marketing/index/assets/index.vue?macro=true";
import { default as indexMsuFpQoPZl5FEVzhQ9Jamq48E7Fa2MaZ9_WNzdWK1_kMeta } from "/src/app/pages/marketing/index/campaigns/index.vue?macro=true";
import { default as mass_45email7yQA5mlcIulN_TMgl3YfvlRPtZydeS_VImmzuear_1YMeta } from "/src/app/pages/marketing/index/mass-email.vue?macro=true";
import { default as mass_45smswhFT1jGlb9Iyuc28Mq6RIoYVVgJQ9fS_GY0rPFMrL5kMeta } from "/src/app/pages/marketing/index/mass-sms.vue?macro=true";
import { default as indexLUTeUptb4855W0m970YRccbxu_Yb745UhhwW_IqNTZsMeta } from "/src/app/pages/marketing/index/reviews/index.vue?macro=true";
import { default as indexQ0u_qrt90kpWCc2k71PwFk2X8qvYazGivRS35i25Y_IMeta } from "/src/app/pages/marketing/index/index.vue?macro=true";
import { default as index6n8q4trNl2yO_KgjrY3jo0cXCEttE8YYYWwhIYaNtY8Meta } from "/src/app/pages/marketing/index.vue?macro=true";
import { default as _91id_932keRpUBYorD_LxLPY99MlilPBxlT3lZe144GSXNbw2EMeta } from "/src/app/pages/message/index/[id].vue?macro=true";
import { default as indexZiSEuy22XEAYK6o30iag7lhR6GzTkjBgdLhCmJxt0foMeta } from "/src/app/pages/message/index.vue?macro=true";
import { default as indexZWa6Cc9XxiLkLnY3xVp2XWDqVy7VPYstsjFxTRzM_2EMeta } from "/src/app/pages/minisite/index.vue?macro=true";
import { default as indexqyWZ9RlhtD8tr1ykqE4ETRXY34f6HBPcWpyphO3AmrAMeta } from "/src/app/pages/onboarding/index.vue?macro=true";
import { default as indexdw1y76qPH8eVRpKEgOmDIabHbbNIt73tNnT68Ttb2gIMeta } from "/src/app/pages/order/index.vue?macro=true";
import { default as _91type_93fxGLxXR_0t_sZ1qq4qBvApYrYeVX8YmMwFk0hngilugMeta } from "/src/app/pages/report/index/[type].vue?macro=true";
import { default as index4vaKNGPPqw8dPsoWf1HuabvhjHSvz1gkQIHOBNjnbzIMeta } from "/src/app/pages/report/index/index.vue?macro=true";
import { default as indexIFE9zHx3MNo_FQi1lAa2VSrU5j_d6lSQnAZ3KHXQNs0Meta } from "/src/app/pages/report/index.vue?macro=true";
import { default as indexYN0MRai2zV3beD_m46gOBWdJpsZJd7zQV8sdPOtqy6EMeta } from "/src/app/pages/roster/index.vue?macro=true";
import { default as day3Vhd9iBPTiX_TuRp1sYAPN_gCoTEW4iL_I04otMbnscMeta } from "/src/app/pages/schedule/index/day.vue?macro=true";
import { default as gridTxDJ1T2Ef31GyP6xzcg1FPYvJ7fymHyNoug_FGiniFIMeta } from "/src/app/pages/schedule/index/grid.vue?macro=true";
import { default as monthhWBU3CF4zv_A8dMKgjV2EyjhrbqoBptqjh1GCoVbn34Meta } from "/src/app/pages/schedule/index/month.vue?macro=true";
import { default as timetablevMNMWdAZgq__lXhPqys_mFVePlKChIjYOGqHQc_OLjsMeta } from "/src/app/pages/schedule/index/timetable.vue?macro=true";
import { default as week7YWL2s4jTJvfe3S__bPd_ZM88dmfIzoyhZV0cI2RFPkMeta } from "/src/app/pages/schedule/index/week.vue?macro=true";
import { default as index3Gab4dhv5airStxlgXynY68FttsMKsgbH3XA5mdkAZAMeta } from "/src/app/pages/schedule/index.vue?macro=true";
import { default as unauthorisedoxXFZavr4fi3FCkU_5w_qFTGmPLQ2uH0H0HAwDtMY3gMeta } from "/src/app/pages/unauthorised.vue?macro=true";
import { default as indexlOQXz4qHz1_tjzzS__aw5L3qkduUse1pUPQ2t0gdaSoMeta } from "/src/app/pages/index.vue?macro=true";
import { default as component_45stub6rf8OGKDOmXgRQbeH7L4Y3ulXNJgTf1t_Zpz0MjpAlgMeta } from "/src/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub6rf8OGKDOmXgRQbeH7L4Y3ulXNJgTf1t_Zpz0MjpAlg } from "/src/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "account-security-and-legal-policy",
    path: "/account/security-and-legal/policy",
    meta: policy9DF_hG4BBbTDb2gG754n2DW2zpRkbq6CdI0hVSAvNrgMeta || {},
    component: () => import("/src/app/pages/account/security-and-legal/policy.vue")
  },
  {
    name: "account-security-and-legal-security",
    path: "/account/security-and-legal/security",
    meta: securitymZU65dGBlXU3EJlPi9mXL8GBVecY7g8uf41hFRvirk4Meta || {},
    component: () => import("/src/app/pages/account/security-and-legal/security.vue")
  },
  {
    name: "account-security-and-legal-sessions",
    path: "/account/security-and-legal/sessions",
    meta: sessionsGKpWzhUrEadGo_gOmPG1VXpROOMOWces91e6RhdoUZYMeta || {},
    component: () => import("/src/app/pages/account/security-and-legal/sessions.vue")
  },
  {
    name: "account-team-roles",
    path: "/account/team/roles",
    meta: rolesWKDH4Cgyux85_TziShT98cWiHwTuxNPBrv66bO01TksMeta || {},
    component: () => import("/src/app/pages/account/team/roles.vue")
  },
  {
    name: "account-team-users",
    path: "/account/team/users",
    meta: usersYGEHu9hGlWwzeEXaO40wmXNMTcQOmNC7Ze8eWedLeGUMeta || {},
    component: () => import("/src/app/pages/account/team/users.vue")
  },
  {
    name: "customer-form-print",
    path: "/customer/form/print",
    meta: printerODQ2EXbDUbkzhqGowuAZIv3M6pA8_N0_YtJZDlOxwMeta || {},
    component: () => import("/src/app/pages/customer/form/print.vue")
  },
  {
    name: "manage-business-account",
    path: "/manage/business/account",
    meta: accountszF_CSfZsuk_QNt17xf0yMZJFNMXZBwmoK9wsDbAx3gMeta || {},
    component: () => import("/src/app/pages/manage/business/account.vue")
  },
  {
    name: "manage-business-address",
    path: "/manage/business/address",
    meta: address__6E2Cf2P0uttEefJegz2VY1lNRp_ZGHcRLpSWNKqFAMeta || {},
    component: () => import("/src/app/pages/manage/business/address.vue")
  },
  {
    name: "manage-business-notes",
    path: "/manage/business/notes",
    meta: notesHB4WWLBjrkxgPl3Pf8iRr7yQ8BD1j0LlPTCBCuaTfrEMeta || {},
    component: () => import("/src/app/pages/manage/business/notes.vue")
  },
  {
    name: "manage-business-schedule",
    path: "/manage/business/schedule",
    meta: schedule8HbE5Lm13iVmJyJChMGX4Y0reKzLQT7o2DWPp_hX4zcMeta || {},
    component: () => import("/src/app/pages/manage/business/schedule.vue")
  },
  {
    name: "manage-business-terminology",
    path: "/manage/business/terminology",
    meta: terminologyZVEP6cyT6R9tB9_9O7lCXywIZfWyHJlkuUPy9XUjNjYMeta || {},
    component: () => import("/src/app/pages/manage/business/terminology.vue")
  },
  {
    name: "manage-communications-email",
    path: "/manage/communications/email",
    meta: emailp6ZZlycKoj0EHWhKyZdPvK1XlZn0EXxWtvcJCkOclXMMeta || {},
    component: () => import("/src/app/pages/manage/communications/email.vue")
  },
  {
    name: "manage-communications-reminders",
    path: "/manage/communications/reminders",
    meta: remindersBbIfiHrX2U7AnsGjx3UCYgdG3XrW1GK4KZEOWxS1T7cMeta || {},
    component: () => import("/src/app/pages/manage/communications/reminders.vue")
  },
  {
    name: "manage-communications-sms",
    path: "/manage/communications/sms",
    meta: smsee3XoPhMnve8GMzef2MJsbh7QNqy9tWWSae80YgP6PIMeta || {},
    component: () => import("/src/app/pages/manage/communications/sms.vue")
  },
  {
    name: "manage-communications-templates",
    path: "/manage/communications/templates",
    meta: templatesXoBz3Nrxi0WZywyd_kuo9p7wZS32ArtrA9Up24DlXlIMeta || {},
    component: () => import("/src/app/pages/manage/communications/templates.vue")
  },
  {
    name: "manage-loyalty-and-promotions-customer-gift-cards",
    path: "/manage/loyalty-and-promotions/customer-gift-cards",
    meta: customer_45gift_45cardsICjyKWFJgrjWui6NgiEqvaV05TPuLF6rU2CydxFdZwgMeta || {},
    component: () => import("/src/app/pages/manage/loyalty-and-promotions/customer-gift-cards.vue")
  },
  {
    name: "manage-loyalty-and-promotions-customer-pass",
    path: "/manage/loyalty-and-promotions/customer-pass",
    meta: customer_45passykpUjXSk_HPeYXCq1ibUVKiEmJTOqYEm3ce6KA7PYOMMeta || {},
    component: () => import("/src/app/pages/manage/loyalty-and-promotions/customer-pass.vue")
  },
  {
    name: "manage-loyalty-and-promotions-pass",
    path: "/manage/loyalty-and-promotions/pass",
    meta: passVtrwwoBD8eNRIfdPqeGOwM16lpLZSgkh3b_DYm2PCa0Meta || {},
    component: () => import("/src/app/pages/manage/loyalty-and-promotions/pass.vue")
  },
  {
    name: "manage-loyalty-and-promotions-promo-codes",
    path: "/manage/loyalty-and-promotions/promo-codes",
    meta: promo_45codesqO5_SuNRZVP4dw8jXgAlBlmFoDJ2JtGf8fwFlLDHJnAMeta || {},
    alias: ["/manage/loyalty-and-promotions/active-promo-codes","/manage/loyalty-and-promotions/expired-promo-codes"],
    component: () => import("/src/app/pages/manage/loyalty-and-promotions/promo-codes.vue")
  },
  {
    name: "manage-marketing-segments",
    path: "/manage/marketing/segments",
    meta: segmentsYxyiKeb9ldct1axSBpgZEF0M3QW4UNDe4MhMJUI7kNcMeta || {},
    component: () => import("/src/app/pages/manage/marketing/segments.vue")
  },
  {
    name: "manage-products-brands",
    path: "/manage/products/brands",
    meta: brandsxSNpnXWwkcz_LeYfdHZZ7QDrb_ixfZJcnoaC9zIWUj4Meta || {},
    component: () => import("/src/app/pages/manage/products/brands.vue")
  },
  {
    name: "manage-products-categories",
    path: "/manage/products/categories",
    meta: categoriesalsCPSXBcyMsnVnGdi4MKPf_SggAr3Lze_ntgaUTuN4Meta || {},
    component: () => import("/src/app/pages/manage/products/categories.vue")
  },
  {
    name: "manage-products-list",
    path: "/manage/products/list",
    meta: listxuG_XoUAUsfRXbYqXfnOvnfCQIW0gH52go4fkEU6KR0Meta || {},
    component: () => import("/src/app/pages/manage/products/list.vue")
  },
  {
    name: "manage-products-purchase-orders",
    path: "/manage/products/purchase-orders",
    meta: purchase_45ordersgrNs8C7v3GDH58Ves6n5_p3nY6uH_1DuozLixDoVK9sMeta || {},
    component: () => import("/src/app/pages/manage/products/purchase-orders.vue")
  },
  {
    name: "manage-products-stock-take",
    path: "/manage/products/stock-take",
    meta: stock_45takeg_0fy32VBQvn_NuK6LC3b5Xyh3kky9TX37Dr2eFt2oIMeta || {},
    component: () => import("/src/app/pages/manage/products/stock-take.vue")
  },
  {
    name: "manage-products-suppliers",
    path: "/manage/products/suppliers",
    meta: supplierssH0Cu6XOBGq2uKxrxTC_tM5QPqt9k08UYX8DbXooRZoMeta || {},
    component: () => import("/src/app/pages/manage/products/suppliers.vue")
  },
  {
    name: "manage-resources-groups",
    path: "/manage/resources/groups",
    meta: groupsydubiX7dqxN4sZkv5kENdRzR6DcbsIL36dTHiRRDMQIMeta || {},
    component: () => import("/src/app/pages/manage/resources/groups.vue")
  },
  {
    name: "manage-resources-list",
    path: "/manage/resources/list",
    meta: listocY3JQItz8V8MGGWx1dHQm5uQgPqTIud0oSCs5fpQrQMeta || {},
    component: () => import("/src/app/pages/manage/resources/list.vue")
  },
  {
    name: "manage-sales-setup-charges",
    path: "/manage/sales-setup/charges",
    meta: chargesppw_mWg_IkuC62agFAaOYK2coDjK0kpbc3hf9N7gXo8Meta || {},
    component: () => import("/src/app/pages/manage/sales-setup/charges.vue")
  },
  {
    name: "manage-sales-setup-discounts",
    path: "/manage/sales-setup/discounts",
    meta: discounts27To8Fzd___qshHaS0a3hGtJHQT61f_yGl1IR_yhj6MMeta || {},
    component: () => import("/src/app/pages/manage/sales-setup/discounts.vue")
  },
  {
    name: "manage-sales-setup-payments",
    path: "/manage/sales-setup/payments",
    meta: payments526hIKL7QMTA_TPW39cWqF1S8z39oFcVjK58IwY64S8Meta || {},
    component: () => import("/src/app/pages/manage/sales-setup/payments.vue")
  },
  {
    name: "manage-sales-setup-taxes",
    path: "/manage/sales-setup/taxes",
    meta: taxesprw1ZQk_ince9gGK3H7yhE8SWyUt2gk7Bcz_sR7_R98Meta || {},
    component: () => import("/src/app/pages/manage/sales-setup/taxes.vue")
  },
  {
    name: "manage-services-aftercare-templates",
    path: "/manage/services/aftercare-templates",
    meta: aftercare_45templateslM3z_79VixukxSDYvVYtPY0OytXCEOfkCsKLZUYBLNgMeta || {},
    component: () => import("/src/app/pages/manage/services/aftercare-templates.vue")
  },
  {
    name: "manage-services-cancellation-reasons",
    path: "/manage/services/cancellation-reasons",
    meta: cancellation_45reasonszZyecoaNKMX8dEgZufPEWkPsuM23nzPIWJIw9InLMK0Meta || {},
    component: () => import("/src/app/pages/manage/services/cancellation-reasons.vue")
  },
  {
    name: "Service categories",
    path: "/manage/services/categories",
    meta: categoriesFtkJIFfvzw9MSHQDVyl8BU1jz_rG0K27z5qKwka6dz8Meta || {},
    component: () => import("/src/app/pages/manage/services/categories.vue")
  },
  {
    name: "manage-services-list",
    path: "/manage/services/list",
    meta: listtfwtm75PoNl8BZ5KJfXlJRDVNjQ0T2wvpQjIVL0aZ6wMeta || {},
    component: () => import("/src/app/pages/manage/services/list.vue")
  },
  {
    name: "manage-services-status-types",
    path: "/manage/services/status-types",
    meta: status_45typesTT9mNsKjAficr211ZvO857455dUwZ42n8g6d12T6oowMeta || {},
    component: () => import("/src/app/pages/manage/services/status-types.vue")
  },
  {
    name: "Employees",
    path: "/manage/team/employees",
    meta: employeesHiGCNLn5aHO_JicWt562UcZM8MjSVAKfY9h2KUUN6u8Meta || {},
    component: () => import("/src/app/pages/manage/team/employees.vue")
  },
  {
    name: "minisite-advanced-domain",
    path: "/minisite/advanced/domain",
    meta: domainmh7mtlErIPLyAmollB_UiRROlBepHrPiE0dR6tGu038Meta || {},
    component: () => import("/src/app/pages/minisite/advanced/domain.vue")
  },
  {
    name: "minisite-advanced-script",
    path: "/minisite/advanced/script",
    meta: scriptUSporitqTDmrfpW2BEO_f_vFQZ8amOJ0iPHWHZtTXrIMeta || {},
    component: () => import("/src/app/pages/minisite/advanced/script.vue")
  },
  {
    name: "minisite-advanced-seo",
    path: "/minisite/advanced/seo",
    meta: seoD7sFOUwEKtu9DbAxcjKeDO_j_HlpBz65i2CtcKzQpAAMeta || {},
    component: () => import("/src/app/pages/minisite/advanced/seo.vue")
  },
  {
    name: "minisite-business-info-hours",
    path: "/minisite/business-info/hours",
    meta: hourseqTekeLoM_oQxm7qOQc5eG6CsxeHs1_66I1ROn7RYIEMeta || {},
    component: () => import("/src/app/pages/minisite/business-info/hours.vue")
  },
  {
    name: "minisite-business-info-social",
    path: "/minisite/business-info/social",
    meta: socialur4v83oAnzmJUMHpLA4C5igI1dOri_hoa_XEUv2U2mkMeta || {},
    component: () => import("/src/app/pages/minisite/business-info/social.vue")
  },
  {
    name: "minisite-pages-booking",
    path: "/minisite/pages/booking",
    meta: bookingQUC_Q50lcFTxjkLsfa_E8NORtVOvZbxfwgbqKLeqmeoMeta || {},
    component: () => import("/src/app/pages/minisite/pages/booking.vue")
  },
  {
    name: "minisite-pages-courses",
    path: "/minisite/pages/courses",
    meta: coursesNhxWyxi8OTwzIJBVbgScg2mTEdLGHuZdCzsZKaf9kDwMeta || {},
    component: () => import("/src/app/pages/minisite/pages/courses.vue")
  },
  {
    name: "minisite-pages-custom-pages",
    path: "/minisite/pages/custom-pages",
    meta: custom_45pagesabYVRDm1zPLQOh7HPH08hsqJ4B5mOJZxH_jwgoMkGO4Meta || {},
    component: () => import("/src/app/pages/minisite/pages/custom-pages.vue")
  },
  {
    name: "minisite-pages-customer",
    path: "/minisite/pages/customer",
    meta: customerBZkFr6qOg6YLgiZzPWWUR_c5OcUQP8LhaZOYGDIqS_AMeta || {},
    component: () => import("/src/app/pages/minisite/pages/customer.vue")
  },
  {
    name: "minisite-pages-gallery",
    path: "/minisite/pages/gallery",
    meta: galleryCG4jf2BcHhsEJdhDVNGTAyb029s7W2Jry6V3qbWzy6kMeta || {},
    component: () => import("/src/app/pages/minisite/pages/gallery.vue")
  },
  {
    name: "minisite-pages-gift-cards",
    path: "/minisite/pages/gift-cards",
    meta: gift_45cardsWUqfDcPsh7qujG_jOecqT5QWSD8NplyCeyNK_D8hyMEMeta || {},
    component: () => import("/src/app/pages/minisite/pages/gift-cards.vue")
  },
  {
    name: "minisite-pages-passes",
    path: "/minisite/pages/passes",
    meta: passesTG8n5YOuQlZLj7atQ_pkQYJsxjDQIPsQd_KOHqbjznkMeta || {},
    component: () => import("/src/app/pages/minisite/pages/passes.vue")
  },
  {
    name: "minisite-pages-reviews",
    path: "/minisite/pages/reviews",
    meta: reviews1I4gTF0cBSUCIt4a7RLw7_QrH0AwOFvNnKeTepH49MQMeta || {},
    component: () => import("/src/app/pages/minisite/pages/reviews.vue")
  },
  {
    name: "roster-print-month",
    path: "/roster/print/month",
    meta: monthSMDkKQc8MaYwdH1goSvXb6UaWgO2_qMaFxRR_PUVQisMeta || {},
    component: () => import("/src/app/pages/roster/print/month.vue")
  },
  {
    name: "roster-print-week",
    path: "/roster/print/week",
    meta: weekMKfGB13s4pVrFrlPvEJdrjJtiyX7GCZoUWQ3EYzmy40Meta || {},
    component: () => import("/src/app/pages/roster/print/week.vue")
  },
  {
    name: "manage-custom-fields-type",
    path: "/manage/custom-fields/:type()",
    meta: _91type_934MLOM4pqa_mH9B_VWrWrizs52LdxB5uSqY475ZYyFrgMeta || {},
    component: () => import("/src/app/pages/manage/custom-fields/[type].vue")
  },
  {
    name: "account-account",
    path: "/account/account",
    meta: accountCP24f_75COwagbGymqxVEUeBav4FiKYnodzYAR_slHoMeta || {},
    component: () => import("/src/app/pages/account/account.vue")
  },
  {
    name: "account-calendar-feeds",
    path: "/account/calendar-feeds",
    meta: calendar_45feedsoyJWY7CbCluURoeQDlJCLXop4jJM4RxkaBcnq0mm_hQMeta || {},
    component: () => import("/src/app/pages/account/calendar-feeds.vue")
  },
  {
    name: "account-exports",
    path: "/account/exports",
    meta: exportsXNXHBOBs3rMSh_LbWQ5TRms3DBrCjpYp7Auc_dTJM_EMeta || {},
    component: () => import("/src/app/pages/account/exports.vue")
  },
  {
    name: "account-inactive",
    path: "/account/inactive",
    meta: inactivengWCyO6QEz_r_D2J18YrbdXntB3V589UNFfvtCm832AMeta || {},
    component: () => import("/src/app/pages/account/inactive.vue")
  },
  {
    name: "account-integrations",
    path: "/account/integrations",
    meta: integrationslESSa_x6Td2I51yzIi8TJ1WHYHkkOuN4AHLvs5kJCuYMeta || {},
    component: () => import("/src/app/pages/account/integrations.vue")
  },
  {
    name: "account-local-cache",
    path: "/account/local-cache",
    component: () => import("/src/app/pages/account/local-cache.vue")
  },
  {
    name: "account-security-and-legal",
    path: "/account/security-and-legal",
    meta: indexqWhAPhoUKjwc_NLMfWs7zb_VpH8Fy5fBbt9iN4jqyyUMeta || {},
    component: () => import("/src/app/pages/account/security-and-legal/index.vue")
  },
  {
    name: "account-subscribe",
    path: "/account/subscribe",
    meta: subscribe_UxwQp1GoYKOV2XQhmWTTDZKkH9TEVC6uJvAjN_qlJoMeta || {},
    component: () => import("/src/app/pages/account/subscribe.vue")
  },
  {
    name: "account-unsubscribe",
    path: "/account/unsubscribe",
    meta: unsubscribeNLqAg08j2lXDQoT2wRjYeu_lcLWi0lkaSGcR0BuAHecMeta || {},
    component: () => import("/src/app/pages/account/unsubscribe.vue")
  },
  {
    name: "account-verify",
    path: "/account/verify",
    meta: verifyC__cthop_ovawlULZHa7OKthul_L6fIRiKZDBViwSgIMeta || {},
    component: () => import("/src/app/pages/account/verify.vue")
  },
  {
    name: "manage-business",
    path: "/manage/business",
    meta: indexxFSUVdhXYklTPnX0M89WBp_veQYSfsHIDiZkUKookNgMeta || {},
    component: () => import("/src/app/pages/manage/business/index.vue")
  },
  {
    name: "manage-course-types",
    path: "/manage/course-types",
    meta: course_45typesMAtGKzBZHpBAGkZxxjSOb98QsMvRrIHgy20IwZr0ZlwMeta || {},
    component: () => import("/src/app/pages/manage/course-types.vue")
  },
  {
    name: "manage-courses",
    path: "/manage/courses",
    meta: coursesAYZTQfO6WOXQiuHhGsTvR2LuicZLddulBLatzFLaIR4Meta || {},
    component: () => import("/src/app/pages/manage/courses.vue")
  },
  {
    name: "manage-custom-fields",
    path: "/manage/custom-fields",
    meta: indexQERyhcMMzr0H31MvjSfRBXEFvPou3JveejBIxJwZcUwMeta || {},
    component: () => import("/src/app/pages/manage/custom-fields/index.vue")
  },
  {
    name: "manage-devices",
    path: "/manage/devices",
    meta: devicessoQTZgNaKlT2366FMfduhfUjrw3YUtpOSkotLYzhkbMMeta || {},
    component: () => import("/src/app/pages/manage/devices.vue")
  },
  {
    name: "manage-forms",
    path: "/manage/forms",
    meta: formssrFT9fGHd3YB_DJarLKH0P4bdRwsAE9FsgbBUQxd60UMeta || {},
    component: () => import("/src/app/pages/manage/forms.vue")
  },
  {
    name: "manage-loyalty-and-promotions",
    path: "/manage/loyalty-and-promotions",
    meta: indexbe1K4ojsa_BFlqBH28wz3FUEYcJHE3_AZBBT5VPlKRoMeta || {},
    component: () => import("/src/app/pages/manage/loyalty-and-promotions/index.vue")
  },
  {
    name: "manage-products",
    path: "/manage/products",
    meta: indexIReB49EiXDDCUXMtDKo6JM3Pp7K4T5MxkOyFetkq4PQMeta || {},
    component: () => import("/src/app/pages/manage/products/index.vue")
  },
  {
    name: "manage-resources",
    path: "/manage/resources",
    meta: indexI55IWuolHv2If94IKlpIQJsQzLtcGQ3VnaScVbgXrVsMeta || {},
    component: () => import("/src/app/pages/manage/resources/index.vue")
  },
  {
    name: "manage-sales-setup",
    path: "/manage/sales-setup",
    meta: indexQRS3XBze27n8bJJ65mQCyWKXrPqnGGeVTy2RJsB7cF0Meta || {},
    component: () => import("/src/app/pages/manage/sales-setup/index.vue")
  },
  {
    name: "manage-services",
    path: "/manage/services",
    meta: indexSB4_M9SNSkXnlSMAh2nMCMn2I6nKWmcuEsHfAwOixxUMeta || {},
    component: () => import("/src/app/pages/manage/services/index.vue")
  },
  {
    name: "manage-team",
    path: "/manage/team",
    meta: indexbGpMPDujlyH__bzB3FV8XU6UlNq_sqTbtwOq7pb3_aMMeta || {},
    component: () => import("/src/app/pages/manage/team/index.vue")
  },
  {
    name: "minisite-advanced",
    path: "/minisite/advanced",
    meta: indexFI_n_dy6drrflA8aoujfZtPB_B5F_YFGtRNUG1newo4Meta || {},
    component: () => import("/src/app/pages/minisite/advanced/index.vue")
  },
  {
    name: "minisite-business-info",
    path: "/minisite/business-info",
    meta: indexW5Wh_3SnSMM2UXzZfjh_g3_EeLapgGXguBQrZpkfkdMMeta || {},
    component: () => import("/src/app/pages/minisite/business-info/index.vue")
  },
  {
    name: "minisite-embed",
    path: "/minisite/embed",
    meta: embed0bDtlTDjUFNQKnCy8uJQJBY_U_Fhwk1ntxVsxwWonesMeta || {},
    component: () => import("/src/app/pages/minisite/embed.vue")
  },
  {
    name: "minisite-menu",
    path: "/minisite/menu",
    meta: menua0QYRDW5_Q9vBQxMegqtQ5l2mBHg_WulGcBCmRlPS4EMeta || {},
    component: () => import("/src/app/pages/minisite/menu.vue")
  },
  {
    name: "minisite-minimise-gaps",
    path: "/minisite/minimise-gaps",
    meta: minimise_45gapszXUpohO6IXWs__sPkPpCSyo_PWeJMj6Lkfe3oc_twr0Meta || {},
    component: () => import("/src/app/pages/minisite/minimise-gaps.vue")
  },
  {
    name: "minisite-new-customers",
    path: "/minisite/new-customers",
    meta: new_45customersBYBY8_slMfTzLk0eMERjhobwTBFHiVglFDbyZQpblHIMeta || {},
    component: () => import("/src/app/pages/minisite/new-customers.vue")
  },
  {
    name: "minisite-pages",
    path: "/minisite/pages",
    meta: indexebAH3N40v_gV98oYMXza_7aonGkaki6Ak7YJSvejlK4Meta || {},
    component: () => import("/src/app/pages/minisite/pages/index.vue")
  },
  {
    name: "minisite-payments",
    path: "/minisite/payments",
    meta: paymentsQexd8rbqRhu3YMy8SOqnEgfy_RhcSOUVhoUfVqB8tl4Meta || {},
    component: () => import("/src/app/pages/minisite/payments.vue")
  },
  {
    name: "minisite-preferences",
    path: "/minisite/preferences",
    meta: preferencesXPSD_GdEPPMbPumV3oH8JRCZCjxx0iCh_gv_oIYcLOUMeta || {},
    component: () => import("/src/app/pages/minisite/preferences.vue")
  },
  {
    name: "minisite-site-notice",
    path: "/minisite/site-notice",
    meta: site_45noticeeX6LXUUf4xxurc8q1cUM_t83N1LswG3zt4iBzbZnwX0Meta || {},
    component: () => import("/src/app/pages/minisite/site-notice.vue")
  },
  {
    name: "minisite-terms-and-policy",
    path: "/minisite/terms-and-policy",
    meta: terms_45and_45policy2vmqO2OL3scTfIZfriMUQFFq8A8HjMLWR4sgUXJxV7oMeta || {},
    component: () => import("/src/app/pages/minisite/terms-and-policy.vue")
  },
  {
    name: "minisite-theme",
    path: "/minisite/theme",
    meta: theme372gY3RNziR5Wlyr0NtWETvoBkGwBsYCS1x6CVbi7aYMeta || {},
    component: () => import("/src/app/pages/minisite/theme.vue")
  },
  {
    name: "template-edit",
    path: "/template/edit",
    meta: editoGIstUjomVhMp9X0gpWwT8Ll9_n8V33QuhtMQUr8Zt8Meta || {},
    component: () => import("/src/app/pages/template/edit.vue")
  },
  {
    name: "integration-id-connect",
    path: "/integration/:id()/connect",
    meta: connectSU3MJ_BEM5uY41PwL0NWTTjuOS7Lsaq9RZYEtb65808Meta || {},
    component: () => import("/src/app/pages/integration/[id]/connect.vue")
  },
  {
    name: "custom-page-id",
    path: "/custom-page/:id()",
    meta: _91id_93qAfSAbMDokR5ZnNKltgsFDPb4U8hgK56jYrvGZZjf2QMeta || {},
    component: () => import("/src/app/pages/custom-page/[id].vue")
  },
  {
    name: "customer-id",
    path: "/customer/:id()",
    component: () => import("/src/app/pages/customer/[id].vue")
  },
  {
    name: "form-id",
    path: "/form/:id()",
    meta: _91id_93miyRBeo2PN9g48GhfcXCBNqntFIlFyZHlP_krCJIkv8Meta || {},
    component: () => import("/src/app/pages/form/[id].vue")
  },
  {
    name: "online-booking-legacy",
    path: "/online-booking/:legacy(.*)*",
    component: () => import("/src/app/pages/online-booking/[...legacy].vue")
  },
  {
    name: "settings-legacy",
    path: "/settings/:legacy(.*)*",
    component: () => import("/src/app/pages/settings/[...legacy].vue")
  },
  {
    name: "account",
    path: "/account",
    component: () => import("/src/app/pages/account/index.vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: index39kX9Yt_pDI8bdbuYMXmSbSM37eYGUI92l686jI6wmwMeta || {},
    component: () => import("/src/app/pages/auth/index.vue"),
    children: [
  {
    name: "auth-index-find",
    path: "find",
    meta: indexMuguBtXlm30uTC2vD78Fk_Tpwt2M1UGVZeogE6naf54Meta || {},
    component: () => import("/src/app/pages/auth/index/find/index.vue"),
    children: [
  {
    name: "auth-index-find-index-accounts",
    path: "accounts",
    meta: accountsvrsDJ_k6QpUyBjvx5M9CNf11TUysmUXQZFGagqxVbfMMeta || {},
    component: () => import("/src/app/pages/auth/index/find/index/accounts.vue")
  },
  {
    name: "auth-index-find-index-code",
    path: "code",
    meta: codeu9mUNqGXMwQGjkp4RnmNHRCaCoxfBAk_xLJ6EZtCbc8Meta || {},
    component: () => import("/src/app/pages/auth/index/find/index/code.vue")
  },
  {
    name: "auth-index-find-index-domain",
    path: "domain",
    component: () => import("/src/app/pages/auth/index/find/index/domain.vue")
  },
  {
    name: "auth-index-find-index-email",
    path: "email",
    meta: emailG9hfbxLlguIgbofI3uuvEWNLKCCkvZ8izKl_bRBB7A0Meta || {},
    component: () => import("/src/app/pages/auth/index/find/index/email.vue")
  }
]
  },
  {
    name: "auth-index-integration",
    path: "integration",
    meta: indextMj4CLDOiHj1mlLQOQULIdGOC81QW907Kgb5QM5lZlMMeta || {},
    component: () => import("/src/app/pages/auth/index/integration/index.vue"),
    children: [
  {
    name: "auth-index-integration-index-guid-connect",
    path: ":guid()/connect",
    component: () => import("/src/app/pages/auth/index/integration/index/[guid]/connect.vue")
  }
]
  },
  {
    name: "auth-index-login",
    path: "login",
    meta: indexHe0l7BP4Xdyl_CNau_jlon4lQNVsDndKB5m2ExvKad8Meta || {},
    component: () => import("/src/app/pages/auth/index/login/index.vue"),
    children: [
  {
    name: "auth-index-login-index-code",
    path: "code",
    meta: codeSdo6Ih5eVjrP4Y5cvgHCSkbn9nHJM2F6_W9glY_wfZgMeta || {},
    component: () => import("/src/app/pages/auth/index/login/index/code.vue")
  },
  {
    name: "auth-index-login-index-email",
    path: "email",
    meta: emailaODphKPYiQrCMYLX09Kj2u0wUZNnQKSEQzOTKzSrawQMeta || {},
    component: () => import("/src/app/pages/auth/index/login/index/email.vue")
  },
  {
    name: "auth-index-login-index-password",
    path: "password",
    meta: password_z_Kfxlx4sZ9xnEHfsYPAwnOjv7oHflsIL5HeBya_S4Meta || {},
    component: () => import("/src/app/pages/auth/index/login/index/password.vue")
  }
]
  },
  {
    name: "auth-index-pin",
    path: "pin",
    component: () => import("/src/app/pages/auth/index/pin.vue")
  },
  {
    name: "auth-index-reset",
    path: "reset",
    meta: indexRhd0JPUqLfkPBr7diAJV2hAgXK3TQrMc_fiSr4ikl_wMeta || {},
    component: () => import("/src/app/pages/auth/index/reset/index.vue"),
    children: [
  {
    name: "auth-index-reset-index-confirm",
    path: "confirm",
    meta: confirm4RBbvZ0H26F5aqAOJviG_QCdi8LEk8IxEsFwe5JViQYMeta || {},
    component: () => import("/src/app/pages/auth/index/reset/index/confirm.vue")
  },
  {
    name: "auth-index-reset-index-email",
    path: "email",
    meta: emailknV3h2wtMqtmNqQycos7_3nY2OPfPBlqTWvEW8L49_QMeta || {},
    component: () => import("/src/app/pages/auth/index/reset/index/email.vue")
  }
]
  },
  {
    name: "auth-index-switch",
    path: "switch",
    meta: switchB6tPwqiiwWdfTELhF34jpxT7XaklTd74JVjz29cst6AMeta || {},
    component: () => import("/src/app/pages/auth/index/switch.vue")
  },
  {
    name: "auth-index-token",
    path: "token",
    meta: tokenzeWz5CC8WOifmBNiy8_U_QpwdSkfbphGF3zfdCSG8t8Meta || {},
    component: () => import("/src/app/pages/auth/index/token.vue")
  },
  {
    name: "auth-index-verify",
    path: "verify",
    meta: verifyd8GUfCLso4ecP41whdDbW2iKR_reIlVUlK5SCIz5Y6kMeta || {},
    component: () => import("/src/app/pages/auth/index/verify.vue")
  }
]
  },
  {
    name: "customer",
    path: "/customer",
    meta: indexVyq32YJh0b_brcA0z1byNUK4E4BXqWOiuc_BiCfHVEYMeta || {},
    component: () => import("/src/app/pages/customer/index.vue")
  },
  {
    name: "demo",
    path: "/demo",
    meta: index8azzhfNUmdzVQNl1TVtUGusgFSsfqBYT_Y7foXhORIMMeta || {},
    component: () => import("/src/app/pages/demo/index.vue")
  },
  {
    name: "elements",
    path: "/elements",
    component: () => import("/src/app/pages/elements.vue")
  },
  {
    name: "manage",
    path: "/manage",
    component: () => import("/src/app/pages/manage/index.vue")
  },
  {
    name: index6n8q4trNl2yO_KgjrY3jo0cXCEttE8YYYWwhIYaNtY8Meta?.name,
    path: "/marketing",
    meta: index6n8q4trNl2yO_KgjrY3jo0cXCEttE8YYYWwhIYaNtY8Meta || {},
    component: () => import("/src/app/pages/marketing/index.vue"),
    children: [
  {
    name: "marketing-index-campaigns-report-id",
    path: "campaigns/report/:id()",
    meta: _91id_93UrP8hLkAX4_b7Vb7udyD7Yzhy9ZTSOXRmatj6rbi0ZoMeta || {},
    component: () => import("/src/app/pages/marketing/index/campaigns/report/[id].vue")
  },
  {
    name: "marketing-index-messages-channel",
    path: "messages/:channel()",
    meta: _91channel_93HXi0V43c1zYz52WZrH2gaIilfn7op9RDkbCcncDDt_kMeta || {},
    component: () => import("/src/app/pages/marketing/index/messages/[channel].vue")
  },
  {
    name: "marketing-index-assets",
    path: "assets",
    meta: index8_R1bDRf421EKs5KPwF8oF_3Q1iqKfNhLJrxan2EkmcMeta || {},
    component: () => import("/src/app/pages/marketing/index/assets/index.vue")
  },
  {
    name: "marketing-index-campaigns",
    path: "campaigns",
    meta: indexMsuFpQoPZl5FEVzhQ9Jamq48E7Fa2MaZ9_WNzdWK1_kMeta || {},
    component: () => import("/src/app/pages/marketing/index/campaigns/index.vue")
  },
  {
    name: "marketing-index-mass-email",
    path: "mass-email",
    component: () => import("/src/app/pages/marketing/index/mass-email.vue")
  },
  {
    name: "marketing-index-mass-sms",
    path: "mass-sms",
    component: () => import("/src/app/pages/marketing/index/mass-sms.vue")
  },
  {
    name: "marketing-index-reviews",
    path: "reviews",
    meta: indexLUTeUptb4855W0m970YRccbxu_Yb745UhhwW_IqNTZsMeta || {},
    component: () => import("/src/app/pages/marketing/index/reviews/index.vue")
  },
  {
    name: "marketing-index",
    path: "",
    component: () => import("/src/app/pages/marketing/index/index.vue")
  }
]
  },
  {
    name: "message",
    path: "/message",
    meta: indexZiSEuy22XEAYK6o30iag7lhR6GzTkjBgdLhCmJxt0foMeta || {},
    component: () => import("/src/app/pages/message/index.vue"),
    children: [
  {
    name: "message-index-id",
    path: ":id()",
    component: () => import("/src/app/pages/message/index/[id].vue")
  }
]
  },
  {
    name: "minisite",
    path: "/minisite",
    meta: indexZWa6Cc9XxiLkLnY3xVp2XWDqVy7VPYstsjFxTRzM_2EMeta || {},
    component: () => import("/src/app/pages/minisite/index.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: indexqyWZ9RlhtD8tr1ykqE4ETRXY34f6HBPcWpyphO3AmrAMeta || {},
    component: () => import("/src/app/pages/onboarding/index.vue")
  },
  {
    name: "order",
    path: "/order",
    meta: indexdw1y76qPH8eVRpKEgOmDIabHbbNIt73tNnT68Ttb2gIMeta || {},
    component: () => import("/src/app/pages/order/index.vue")
  },
  {
    name: "Reports",
    path: "/report",
    meta: indexIFE9zHx3MNo_FQi1lAa2VSrU5j_d6lSQnAZ3KHXQNs0Meta || {},
    component: () => import("/src/app/pages/report/index.vue"),
    children: [
  {
    name: "Report",
    path: ":type()",
    meta: _91type_93fxGLxXR_0t_sZ1qq4qBvApYrYeVX8YmMwFk0hngilugMeta || {},
    component: () => import("/src/app/pages/report/index/[type].vue")
  },
  {
    name: "report-index",
    path: "",
    component: () => import("/src/app/pages/report/index/index.vue")
  }
]
  },
  {
    name: "roster",
    path: "/roster",
    meta: indexYN0MRai2zV3beD_m46gOBWdJpsZJd7zQV8sdPOtqy6EMeta || {},
    component: () => import("/src/app/pages/roster/index.vue")
  },
  {
    name: "schedule",
    path: "/schedule",
    component: () => import("/src/app/pages/schedule/index.vue"),
    children: [
  {
    name: "schedule-index-day",
    path: "day",
    component: () => import("/src/app/pages/schedule/index/day.vue")
  },
  {
    name: "schedule-index-grid",
    path: "grid",
    component: () => import("/src/app/pages/schedule/index/grid.vue")
  },
  {
    name: "schedule-index-month",
    path: "month",
    component: () => import("/src/app/pages/schedule/index/month.vue")
  },
  {
    name: "schedule-index-timetable",
    path: "timetable",
    component: () => import("/src/app/pages/schedule/index/timetable.vue")
  },
  {
    name: "schedule-index-week",
    path: "week",
    component: () => import("/src/app/pages/schedule/index/week.vue")
  }
]
  },
  {
    name: "unauthorised",
    path: "/unauthorised",
    meta: unauthorisedoxXFZavr4fi3FCkU_5w_qFTGmPLQ2uH0H0HAwDtMY3gMeta || {},
    component: () => import("/src/app/pages/unauthorised.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/src/app/pages/index.vue")
  },
  {
    name: component_45stub6rf8OGKDOmXgRQbeH7L4Y3ulXNJgTf1t_Zpz0MjpAlgMeta?.name,
    path: "/appointments",
    component: component_45stub6rf8OGKDOmXgRQbeH7L4Y3ulXNJgTf1t_Zpz0MjpAlg
  }
]